export default __webpack_public_path__ + "static/media/Pauline.18e6d9b4.jpg";